import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorClaimYields = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M18.011 14.02a.739.739 0 0 1 .945 1.135l-4.474 4.024a2.699 2.699 0 0 1-1.805.693H8a1.75 1.75 0 0 0-1.75 1.75v.614a.75.75 0 0 0 1.5 0v-.614a.25.25 0 0 1 .25-.25h4.677a4.199 4.199 0 0 0 2.808-1.077l4.474-4.025c1.352-1.215.768-3.45-1.006-3.848a2.239 2.239 0 0 0-1.856.41l-3.81 2.93c.114-1.317-.898-2.612-2.396-2.612H6.118a4.796 4.796 0 0 0-4.706 3.878l-.115.588a2.54 2.54 0 0 0-.047.486v4.138a.75.75 0 0 0 1.5 0v-4.138c0-.067.006-.134.02-.2l.114-.587a3.296 3.296 0 0 1 3.234-2.665h4.773a.9.9 0 0 1 .722 1.438.745.745 0 0 0-.058.09H7.5a.75.75 0 0 0 0 1.5h5.16a1.75 1.75 0 0 0 1.067-.362l4.284-3.296Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M12.5 2.75a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5ZM6.75 7a5.75 5.75 0 1 1 11.5 0 5.75 5.75 0 0 1-11.5 0Z"
    />
    <path
      fill="#F7A600"
      d="M15.25 7a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0ZM20.685 2.8l.052.312a2.372 2.372 0 0 0 1.874 1.936 2.372 2.372 0 0 0-1.875 1.936l-.051.312-.05-.298a2.396 2.396 0 0 0-1.877-1.95 2.372 2.372 0 0 0 1.875-1.936l.052-.312Z"
    />
  </svg>
);
export default SvgTwoColorClaimYields;
